'use strict';

class OCR {
  constructor($sce, originatorService) {
    this.$sce = $sce;
    this.originatorService = originatorService;
  }

  $onInit() {
    this.processing = false;

    this.params = {
      name: null,
      email: null,
      mobile: null
    };

    this.status = false;
    this.processing = false;

    this.load();
  }

  load() {
    this.originatorService.getOCR()
      .then((resp) => {
        this.agreement = resp.data;

        if (resp.status === 204) {
          this.status = false;
        } else {
          this.status = true;
        }
      });
  }

  getStatus(text) {
    const strings = {
      ACTIVE: '<i class="fa fa-check"></i> Aktiv',
      INACTIVE: '<i class="fa fa-times"></i> Inaktiv',
      PENDING: '<i class="fa fa-refresh"></i> Bestillingen er under behandling',
      AWAITING_SIGNING: '<i class="fa fa-refresh"></i> Avventer signering av avtale'
    };

    if (text && strings[text]) {
      return this.$sce.trustAsHtml(strings[text]);
    }
  }

  register() {
    this.processing = true;

    this.originatorService.registerOCR(this.params)
      .then(() => {
        this.processing = false;
        this.load();
      })
      .catch(() => {
        this.processing = false;
      });
  }
}

OCR.$inject = ['$sce', 'originatorService'];

const ocr = {
  require: {
    accountIntegrations: '^^accountIntegrations'
  },
  controller: OCR,
  template: `

    <div ng-hide="$ctrl.accountIntegrations.originator.bankAccount.kid && !$ctrl.status">
      <h3 class="subheader">KID</h3>

      <fieldset>
        <div class="row">
          <div class="large-3 columns">
            <img src="/assets/img/nets.png" alt="Nets" />
          </div>

          <div class="large-9 columns" ng-hide="$ctrl.status">
<!--            <p>Ved bruk av KID-nummer på regningen vil SendRegning få beskjed fra Nets om alle betalinger med KID og registrere betalingene i systemet automatisk.<br>Vær oppmerksom på at i tillegg til våre <a href="/priser">priser</a> vil banken din ta betalt for denne tjenesten, som kalles OCR-avtale. Prisene varierer fra bank til bank, så kontakt din bank for å finne ut hva det vil koste for deg.</p>-->

<!--            <p>Når du bestiller KID-nummer vil kontaktpersonen få en e-post med en lenke til signering av standardvilkårene for OCR-avtaler. Avtalen må signeres med BankID av en som har fullmakt til å bestille tjenester på vegne av eieren av SendRegning-kontoen.</p>-->

<!--            <p>For enkeltpersonforetak er det viktig å sørge for at bankkontoen som er registrert i SendRegning eies av bedriften. Det er <strong>ikke</strong> mulig å bestille KID for private bankkontoer.</p>-->

<!--            <form ng-submit="$ctrl.register()">-->
<!--              <h3 class="subheader">Opplysninger om kontaktperson</h3>-->

<!--              <div>-->
<!--                <label for="name">Navn</label>-->
<!--                <input type="text" id="name" name="name" autocomplete="name" ng-model="$ctrl.params.name" placeholder="Ola Nordmann" maxlength="64" required>-->
<!--              </div>-->

<!--              <div>-->
<!--                <label for="email">E-postadresse</label>-->
<!--                <input type="email" id="email" name="email" autocomplete="email" ng-model="$ctrl.params.email" maxlength="64" placeholder="ola@nordmann.no" required>-->
<!--              </div>-->

<!--              <div>-->
<!--                <label for="mobile">Mobilnummer</label>-->
<!--                <div class="row collapse">-->
<!--                  <div class="small-2 columns">-->
<!--                    <span class="prefix">+47</span>-->
<!--                  </div>-->
<!--                  <div class="small-10 columns">-->
<!--                    <input type="tel" id="mobile" name="mobile" autocomplete="tel" ng-model="$ctrl.params.mobile" required mobile-number-validator>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->

<!--              <button type="submit" class="button" ng-disabled="$ctrl.processing">Bestill KID</button>-->
<!--            </form>-->

              <p>Ved bruk av KID-nummer på regningen vil SendRegning få beskjed fra Nets om alle betalinger med KID og registrere betalingene i systemet automatisk.</p>
              <p>Vær oppmerksom på at i tillegg til våre priser vil banken din ta betalt for denne tjenesten. Prisene varierer fra bank til bank, så kontakt din bank for å finne ut hva det vil koste for deg.</p>
              <p>For å bestille KID-nummer kontakter du banken din og får et bestillingsskjema for en OCR- eller CREMUL-avtale. Send så skjemaet til hjelp@sendregning.no, så fyller vi det ut for deg og returnerer det med videre instruksjoner.</p>
          </div>

          <div class="large-9 columns" ng-show="$ctrl.status">
            <p>
              Status: <span ng-bind-html="$ctrl.getStatus($ctrl.agreement.status)"></span><br>
              Organisasjonsnummer: <b>{{ $ctrl.agreement.organisationNumber | organisationNumberFormat }}</b><br>
              Kontonummer: <b>{{ $ctrl.agreement.accountNumber | accountNumberFormat }}</b>
            </p>
          </div>
        </div>
      </fieldset>
    </div>
  `
};

angular
  .module('SendRegning')
  .component('ocr', ocr);
